import { UserPermissions } from '@creditsights/api-ui-web';
import { NotificationMode, RiskProductAlert } from '../../../../../models/Preference';
import { hasPermissionToRp } from '../../../../../utils/permissionsUtils';

export interface AlertOption {
  value: NotificationMode | RiskProductAlert;
  label: string;
}

export const emailAlertOptions: AlertOption[] = [
  {
    label: 'Instant',
    value: NotificationMode.Instant,
  },
  {
    label: 'Digest',
    value: NotificationMode.Digest,
  },
];

export const riskProductAlertOptions: AlertOption[] = [
  {
    label: 'Daily',
    value: RiskProductAlert.Daily,
  },
  {
    label: 'Weekly',
    value: RiskProductAlert.Weekly,
  },
];

export const hasAnyAlertSelected = (
  userPermissions: UserPermissions | undefined,
  emailAlert: NotificationMode,
  riskProductAlert: RiskProductAlert
): boolean => {
  if (hasPermissionToRp(userPermissions)) {
    return emailAlert !== NotificationMode.None || riskProductAlert !== RiskProductAlert.None;
  }
  return emailAlert !== NotificationMode.None;
};
